import api from '../utils/api';

// List files for a project
export const listFiles = async (projectId) => {
  const res = await api.get(`/projects/${projectId}/files`);
  // Support payloads { files: [...] } or array
  return Array.isArray(res.data) ? res.data : (res.data.files || []);
};

// Upload multiple files with progress callback (0-100)
export const uploadFiles = async (projectId, files, onProgress) => {
  const formData = new FormData();
  files.forEach((f) => formData.append('files', f));
  const res = await api.post(`/projects/${projectId}/files`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (evt) => {
      if (!onProgress || !evt.total) return;
      const p = Math.round((evt.loaded * 100) / evt.total);
      onProgress(p);
    }
  });
  return Array.isArray(res.data) ? res.data : (res.data.files || []);
};

// Download file (returns Blob)
export const downloadFile = async (projectId, fileId) => {
  const res = await api.get(`/projects/${projectId}/files/${fileId}`, { responseType: 'blob' });
  return res.data;
};

// Delete file
export const deleteFile = async (projectId, fileId) => {
  await api.delete(`/projects/${projectId}/files/${fileId}`);
};
